module.exports = __webpack_public_path__ + "img/ipad-connected-en.7881ee59.svg";